import React, { useState, useEffect } from "react";
// import Controls from "../FormsControls/Control";
import { AppBar, Grid } from "@material-ui/core";
import BreadcrumbsGrp from './BreadcrumbsGrp';
import ThemeControls from "./AllThemesControl";
// import MenuIcon from '@mui/icons-material/Menu';
// import IconButton from '@mui/material/IconButton';
import { useNavigate, useLocation } from 'react-router-dom';
import { SideMenuJson } from "../modules/menu";
import { ReactComponent as View } from '../images/Table/Eye.svg';

import { IoMdAdd } from "react-icons/io";
import { IoEyeOutline } from "react-icons/io5";

// SubHeaderJson
import subHeaderJson from "./subHeaderJson.json";
export default function Subheader(props) {
  //console.log("SubHeaderRenders")
  const sideMenuJson = SideMenuJson;
  const { open, handleDrawerOpen } = props;
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const [linkText, setLinkText] = useState("")
  const [buttonText, setButtonText] = useState("")
  const [subHeaderTitle, setSubHeaderTitle] = useState("");
  const [buttonIcon, setButtonIcon] = useState("");
  let navigate = useNavigate();
  let path = useLocation();
  let pathString = String(path.pathname)


  //   useEffect(()=>{

  //     Object.keys(sideMenuJson.menus).forEach((key,index)=> {
  //       sideMenuJson.menus[key].item.map((obj, key) => {
  //       let  b= obj;
  //       if(pathString === obj.path && obj.subheadertitle){
  //         setSubHeaderTitle(obj.subheadertitle)
  //       }
  //       if(pathString === obj.path && obj.topButtonText){
  //         setButtonText(obj.topButtonText);
  //       }
  //       if(pathString === obj.path && obj.buttonLink){
  //         setLinkText(pathString);
  //         // setLinkText(obj.buttonLink)
  //       }
  //       if(obj.items){
  //         obj.items.map((item, key) => {
  //             if(pathString === item.path && item.topButtonText){
  //               setButtonText(item.topButtonText);
  //             }
  //             if(pathString === item.path && item.subheadertitle){
  //               setSubHeaderTitle(item.subheadertitle)
  //             }
  //             if(pathString === item.path && item.buttonLink){
  //               setLinkText(pathString);
  //               // setLinkText(item.buttonLink)
  //             }
  //         })
  //       }
  //     })
  //   })
  //   })

  const handleClick = () => {
    navigate(linkText);
  }
  //   useEffect(()=>{
  //     SetTitleSubHeader(pathString)
  //   })
  //   //rendering subheader
  // useEffect(()=>{
  //   if(pathString){
  //     let str = String(SetTitleSubHeader(pathString));
  //     setSubHeaderTitle(str)
  //   }
  // })


  useEffect(() => {
    if (subHeaderJson[pathString]) {
      setLinkText(subHeaderJson[pathString]['buttonLink']);
      setSubHeaderTitle(subHeaderJson[pathString]['subheadertitle']);
      setButtonText(subHeaderJson[pathString]['topButtonText']);
      setButtonIcon(subHeaderJson[pathString]['buttonIcon']);
    }
  })

  // if(subHeaderTitle){
  return (
    <div className={classes.appSubBar} >
      <div className={classes.topSp}>

        <BreadcrumbsGrp />
        {subHeaderTitle&&<div className={classes.center}>
          <div className={classes.shh}>

            {subHeaderTitle ? <h1 className={classes.heading}>
              {subHeaderTitle}</h1> : <h1 className={classes.heading}>
            </h1>}

          </div>

          {buttonText.trim() !== "" && buttonIcon === "Create" ? <div className={classes.subBtn} onClick={handleClick}><IoMdAdd />{buttonText}</div> : buttonText.trim() !== "" && buttonIcon === "View" ? <div className={classes.subBtn} onClick={handleClick}><IoEyeOutline />{buttonText}</div> : <></>}

        </div>}
      </div>
    </div>

  )
  // }else{
  //     return(
  //       <div>Loading.....</div>
  //     )
  //   }
}